import { IconButton, Preview } from "@evergis/ui";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { DateFormat, formatDate } from "../../../../../../utils/date";
import { JSONAttributeValue } from "../../types";
import { AttachmentAddButton } from "./AttachmentAddButton";
import { FileImagePreview } from "./FileImagePreview";
import { getFileType } from "./getFileType";
import {
  AddButtonWrapper,
  AttachmentsAddButtonContainer,
  AttachmentsListContainer,
  ListActions,
  ListIcon,
  ListItemContainer,
  ListItemDate,
  ListItemDescription,
  ListItemMeta,
  ListItemName,
  ShowMoreButton,
} from "./styled";
import { FileType } from "./types";
import { useAttachmentItems } from "./useAttachmentsItems";

export interface AttachmentsListProps {
  items?: JSONAttributeValue[];
  isEdit: boolean;
  onChange?: (value?: JSONAttributeValue[]) => void;
}

const PAGE_SIZE = 8;

export const AttachmentsList: FC<AttachmentsListProps> = ({ items, isEdit, onChange }) => {
  const { t } = useTranslation("featureCard");
  const { onPreview, onAdd, onDelete, onShowMore, page, previewItems, previewOpen, setPreviewOpen } =
    useAttachmentItems(items, onChange);

  return (
    <>
      <AttachmentsListContainer>
        {isEdit && (
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          <AttachmentAddButton hiddenItems={items} onApply={onAdd} offset={[-32, -8]}>
            <AttachmentsAddButtonContainer>
              <AddButtonWrapper>
                <IconButton kind={"feature_add"} />
                <span>{t("addFile")}</span>
              </AddButtonWrapper>
            </AttachmentsAddButtonContainer>
          </AttachmentAddButton>
        )}
        {items &&
          items
            .slice(0, isEdit ? PAGE_SIZE * page - 1 : PAGE_SIZE * page)
            .map(({ mimeType, link, isExternal, name: fileName, date }) => {
              const fileType = getFileType(mimeType, fileName);

              return (
                <ListItemContainer onClick={() => onPreview(fileName)}>
                  <ListItemMeta>
                    {fileType !== FileType.IMAGE && <ListIcon fileType={fileType} />}
                    {fileType === FileType.IMAGE && (
                      <FileImagePreview size={"1.5rem"} isExternal={isExternal} link={link} />
                    )}
                    <ListItemDescription>
                      <ListItemName>{fileName}</ListItemName>
                      <ListItemDate>{formatDate(date, { dateFormat: DateFormat.DateTime })}</ListItemDate>
                    </ListItemDescription>
                  </ListItemMeta>

                  {isEdit && (
                    <ListActions onClick={event => event.stopPropagation()}>
                      <IconButton kind={"delete"} onClick={() => onDelete(link)} />
                    </ListActions>
                  )}
                </ListItemContainer>
              );
            })}
      </AttachmentsListContainer>
      {items?.length > (isEdit ? page * PAGE_SIZE - 1 : page * PAGE_SIZE) && (
        <ShowMoreButton onClick={onShowMore}>
          {t("showMore")}{" "}
          {items?.length - (isEdit ? page * PAGE_SIZE - 1 : page * PAGE_SIZE) < PAGE_SIZE
            ? items?.length - (isEdit ? page * PAGE_SIZE - 1 : page * PAGE_SIZE)
            : PAGE_SIZE}
        </ShowMoreButton>
      )}
      <Preview images={previewItems} isOpen={previewOpen} onClose={() => setPreviewOpen(false)} />
    </>
  );
};
